import { render } from "./JobTermForm.vue?vue&type=template&id=66ac8837"
import script from "./JobTermForm.vue?vue&type=script&lang=js"
export * from "./JobTermForm.vue?vue&type=script&lang=js"

import "./JobTermForm.vue?vue&type=style&index=0&id=66ac8837&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__